import { BehaviorSubject, Observable } from "rxjs";
import { inject, injectable, singleton } from "tsyringe";
import { ExtensionContext } from "../../common/models/extension-config";
import { Module } from "../../common/module";
import { CommonModule } from "../common.module";

@singleton()
export class UrlChangeListenerModule extends Module {
    public name: string = 'UrlChangeListenerModule';
    public acceptedLicenseFlags: string[] = [];
    public shouldRun(context: ExtensionContext): boolean { return false; }
    constructor(@inject(CommonModule) private common: CommonModule) {
        super([common]);
    }
    public get event(): Observable<string> { return this._event!; }
    private _event: BehaviorSubject<string> | undefined;
    public async run(): Promise<void> {
        this._event = new BehaviorSubject<string>(location.href);
        // depending on if we are in vizql or vizportal, implement different changes
        switch (window.stm.config.context) {
            case ExtensionContext.vizportal:
                window.addEventListener('hashchange', () => this._event!.next(location.href));
                break;
            case ExtensionContext.vizql:
                let url = location.href;
                setInterval(() => {
                    if (url !== location.href) {
                        this._event!.next(location.href)
                    }
                    url = location.href;
                }, 1000);
                break;
        }
    }

}